// Mock Markets Data
import type { Market } from '@/types';

export const mockMarkets: Market[] = [
  // Iran-related markets
  {
    id: 'khamenei-out-supreme-leader',
    question: 'Khamenei out as Supreme Leader of Iran before 2027?',
    category: 'Geopolitics',
    status: 'open',
    endsAt: '2027-01-01T05:00:00Z',
    icon: 'globe',
    outcomes: [
      {
        id: 'yes-khamenei',
        name: 'Yes',
        price: 0.21,
        liquidity: 500000,
        volume: 14000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
      {
        id: 'no-khamenei',
        name: 'No',
        price: 0.79,
        liquidity: 500000,
        volume: 14000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
    ],
    slug: '',
    title: '',
    description: '',
    image: '',
    tags: [],
    endDate: '',
    volume: 28000000,
    liquidity: 1000000,
    createdAt: '',
  },
  {
    id: 'iranian-regime-fall-2027',
    question: 'Will the Iranian regime fall before 2027?',
    category: 'Geopolitics',
    status: 'open',
    endsAt: '2027-01-01T05:00:00Z',
    icon: 'globe',
    outcomes: [
      {
        id: 'yes-regime-fall',
        name: 'Yes',
        price: 0.52,
        liquidity: 500000,
        volume: 1000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
      {
        id: 'no-regime-fall',
        name: 'No',
        price: 0.48,
        liquidity: 500000,
        volume: 1000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
    ],
    slug: '',
    title: '',
    description: '',
    image: '',
    tags: [],
    endDate: '',
    volume: 2000000,
    liquidity: 1000000,
    createdAt: '',
  },
  {
    id: 'israel-strikes-iran-jan31',
    question: 'Israel strikes Iran by January 31, 2026?',
    category: 'Geopolitics',
    status: 'open',
    endsAt: '2026-01-31T05:00:00Z',
    icon: 'globe',
    outcomes: [
      {
        id: 'yes-israel-strike',
        name: 'Yes',
        price: 0.38,
        liquidity: 500000,
        volume: 5000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
      {
        id: 'no-israel-strike',
        name: 'No',
        price: 0.62,
        liquidity: 500000,
        volume: 5000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
    ],
    slug: '',
    title: '',
    description: '',
    image: '',
    tags: [],
    endDate: '',
    volume: 10000000,
    liquidity: 1000000,
    createdAt: '',
  },
  // Sports markets
  {
    id: 'super-bowl-champion-2026',
    question: 'Super Bowl Champion 2026',
    category: 'Sports',
    status: 'open',
    endsAt: '2026-02-15T05:00:00Z',
    icon: 'sports',
    outcomes: [
      {
        id: 'seattle',
        name: 'Seattle',
        price: 0.24,
        liquidity: 500000,
        volume: 337000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
      {
        id: 'los-angeles-r',
        name: 'Los Angeles R',
        price: 0.21,
        liquidity: 500000,
        volume: 337000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
    ],
    slug: '',
    title: '',
    description: '',
    image: '',
    tags: [],
    endDate: '',
    volume: 674000000,
    liquidity: 1000000,
    createdAt: '',
  },
  // Politics markets
  {
    id: 'portugal-presidential-election',
    question: 'Portugal Presidential Election',
    category: 'Politics',
    status: 'open',
    endsAt: '2026-01-26T05:00:00Z',
    icon: 'portugal',
    outcomes: [
      {
        id: 'antonio-seguro',
        name: 'António José Seguro',
        price: 0.67,
        liquidity: 500000,
        volume: 52500000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
      {
        id: 'joao-figueired',
        name: 'João Cotrim Figueired',
        price: 0.19,
        liquidity: 500000,
        volume: 52500000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
    ],
    slug: '',
    title: '',
    description: '',
    image: '',
    tags: [],
    endDate: '',
    volume: 105000000,
    liquidity: 1000000,
    createdAt: '',
  },
  // Additional markets to fill the page
  {
    id: 'us-next-strikes-iran',
    question: 'US next strikes Iran on...?',
    category: 'Geopolitics',
    status: 'open',
    endsAt: '2026-02-15T05:00:00Z',
    icon: 'globe',
    outcomes: [
      {
        id: 'jan-25',
        name: 'January 25',
        price: 0.28,
        liquidity: 500000,
        volume: 15000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
      {
        id: 'feb-5',
        name: 'February 5',
        price: 0.35,
        liquidity: 500000,
        volume: 15000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
    ],
    slug: '',
    title: '',
    description: '',
    image: '',
    tags: [],
    endDate: '',
    volume: 30000000,
    liquidity: 1000000,
    createdAt: '',
  },
  {
    id: 'logan-paul-pikachu-sale',
    question: "Logan Paul's Pikachu Illustrator Sale Price",
    category: 'Culture',
    status: 'open',
    endsAt: '2026-12-31T05:00:00Z',
    icon: 'popular-names',
    outcomes: [
      {
        id: 'over-5m',
        name: 'Over $5M',
        price: 0.45,
        liquidity: 500000,
        volume: 2000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
      {
        id: 'under-5m',
        name: 'Under $5M',
        price: 0.55,
        liquidity: 500000,
        volume: 2000000,
        bestBid: 0,
        bestAsk: 0,
        lastTradePrice: 0,
        spread: 0,
      },
    ],
    slug: '',
    title: '',
    description: '',
    image: '',
    tags: [],
    endDate: '',
    volume: 4000000,
    liquidity: 1000000,
    createdAt: '',
  },
];
